import { Component } from '@angular/core';

@Component({
  selector: 'app-product-priceunits-extends',
  templateUrl: './product-priceunits-extends.component.html',
  styleUrls: ['./product-priceunits-extends.component.css']
})
export class ProductPriceunitsExtendsComponent {

  item:any = null;
  getDataProduct(product:any=null){
    this.item = product;
  }

}
